import { Injectable } from "@angular/core";
import { BackendService } from "../../../core/services/backend-service";

export interface UserResponse {
  vinciId: string;
  createdAt: string;
  lastLoginAt?: string | null;
}

@Injectable({
  providedIn: "root",
})
export class UsersApiService extends BackendService {
  constructor() {
    super();
  }

  loginMe(): Promise<UserResponse> {
    return this.get<UserResponse>("api/users/me");
  }
}
